import { createGlobalStyle } from 'styled-components';
import './docs/css/common.scss'
import './docs/fonts/pe7stroke/css/pe-icon-7-stroke.scss'
import './docs/css/themify-icons.scss'
import './docs/css/flaticon.scss'
const GlobalStyle = createGlobalStyle;

export default GlobalStyle;
